/* Capitol style — giỏ hàng nhanh (sections/gv-minicart.liquid).
   - window.GVMini.open(html?) — mở (html = khung mới lấy từ Shopify sau khi thêm vào giỏ, khỏi tải lại).
   - Bấm icon giỏ hàng trên header → mở giỏ nhanh thay vì sang trang /cart (trừ khi đang ở trang /cart).
   - Đổi số lượng / xoá tại chỗ; báo cho header (số trên icon) bằng sự kiện chuẩn của Shopify.
   - Đóng: nút X, bấm ra ngoài, phím Esc. Giữ phím Tab trong ngăn kéo khi đang mở. */
const root = document.getElementById('gv-minicart');
let Ev = null;
try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent || null; } catch (_) { Ev = null; }
const EVT = (Ev && Ev.eventName) || 'shopify:cart:lines-update';
const R = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
const url = (p) => R.replace(/\/$/, '') + p;
const SID = 'gv-minicart';

if (root && !window.GVMini) {
  const panel = root.querySelector('.gvm__panel');
  const mq = window.matchMedia('(max-width: 768px)');
  const isDrop = () => root.classList.contains('gvm--dropdown') && !mq.matches;
  let stale = false, trigger = null, closing = null, busy = false;

  const say = (t) => { const l = root.querySelector('[data-gvm-live]'); if (l) { l.textContent = ''; setTimeout(() => { l.textContent = t; }, 50); } };
  function cartIcon() { return document.querySelector('.gv-header a[href$="/cart"], #header-group a[href$="/cart"], header-actions a[href$="/cart"]'); }
  function place() {
    const ic = cartIcon();
    const b = ic ? ic.getBoundingClientRect() : null;
    const top = b && b.bottom > 0 ? Math.round(b.bottom + 8) : 16;
    root.style.setProperty('--gvm-top', top + 'px');
  }
  function swap(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const n = doc.getElementById('gv-minicart');
    if (!n) return false;
    ['[data-gvm-body]', '[data-gvm-foot]'].forEach((s) => {
      const a = root.querySelector(s), b = n.querySelector(s);
      if (a && b) { a.replaceWith(b); }
    });
    root.dataset.count = n.dataset.count;
    stale = false;
    return true;
  }
  async function refresh() {
    try {
      const r = await fetch(url('/?sections=' + SID), { headers: { Accept: 'application/json' } });
      const j = await r.json();
      if (j && j[SID]) swap(j[SID]);
    } catch (_) {}
  }
  function trap(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || isDrop()) return;
    const f = [...panel.querySelectorAll('a[href],button:not([disabled]),input,[tabindex="0"]')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function outside(e) { if (isDrop() && !panel.contains(e.target) && !(trigger && trigger.contains(e.target))) close(); }
  async function open(html, from) {
    clearTimeout(closing);
    if (html) swap(html); else if (stale) await refresh();
    trigger = from || document.activeElement;
    place();
    root.hidden = false;
    // ép trình duyệt vẽ vị trí ban đầu rồi mới thêm is-open → hiệu ứng trượt chạy, không phụ thuộc requestAnimationFrame (tab chạy nền)
    void panel.offsetWidth;
    root.classList.add('is-open');
    if (!isDrop()) document.documentElement.classList.add('gvm-lock');
    const ic = cartIcon(); if (ic) ic.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', trap);
    setTimeout(() => document.addEventListener('click', outside, true), 0);
    panel.focus({ preventScroll: true });
    const c = parseInt(root.dataset.count, 10) || 0;
    say(c ? c + (c === 1 ? ' item' : ' items') + ' in cart' : 'Your cart is empty');
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('gvm-lock');
    document.removeEventListener('keydown', trap);
    document.removeEventListener('click', outside, true);
    const ic = cartIcon(); if (ic) ic.setAttribute('aria-expanded', 'false');
    closing = setTimeout(() => { root.hidden = true; }, 300);
    if (trigger && trigger.focus && document.contains(trigger)) trigger.focus({ preventScroll: true });
  }

  /* Đổi số lượng / xoá */
  async function change(line, qty) {
    if (busy) return;
    const it = root.querySelector('.gvm__item[data-line="' + line + '"]');
    const err = it && it.querySelector('[data-gvm-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (it) it.classList.add('is-busy');
    root.classList.add('is-busy'); busy = true;
    let d = null;
    if (Ev && Ev.createPromise) {
      d = Ev.createPromise();
      root.dispatchEvent(new Ev({ action: qty > 0 ? 'update' : 'remove', context: 'cart', lines: [{ id: it ? it.dataset.key : '', quantity: qty }], promise: d.promise }));
    }
    try {
      const res = await fetch(url('/cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: qty, sections: SID, sections_url: location.pathname }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok || j.status || j.errors) {
        if (d) d.resolve({ cart: undefined, detail: { didError: true, source: 'gv-minicart' } });
        if (it) { it.classList.remove('is-busy'); const inp = it.querySelector('[data-gvm-qin]'); if (inp) inp.value = inp.defaultValue; }
        if (err) { err.textContent = j.description || j.message || 'This quantity is not available.'; err.hidden = false; }
        return;
      }
      if (d) { let c; try { c = Ev.createCartFromAjaxResponse(j); } catch (_) { c = undefined; } d.resolve({ cart: c, detail: { items: j.items, itemCount: j.item_count, source: 'gv-minicart', didError: false } }); }
      if (!(j.sections && j.sections[SID] && swap(j.sections[SID]))) await refresh();
      say(qty > 0 ? 'Cart updated' : 'Item removed');
      const f = root.querySelector('.gvm__item[data-line="' + line + '"] [data-gvm-qin]') || root.querySelector('.gvm__cont') || panel;
      f.focus({ preventScroll: true });
    } catch (_) {
      if (d) d.resolve({ cart: undefined, detail: { didError: true, source: 'gv-minicart' } });
      if (it) it.classList.remove('is-busy');
      if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
    } finally { busy = false; root.classList.remove('is-busy'); }
  }
  const timers = {};
  function clampQty(inp, v) {
    const min = parseInt(inp.min, 10) || 1, step = parseInt(inp.step, 10) || 1, max = parseInt(inp.max, 10);
    if (isNaN(v)) v = min;
    if (v < 0) v = 0;
    if (v > 0 && v < min) v = min;
    if (v > 0 && step > 1) v = Math.max(min, Math.round(v / step) * step);
    if (!isNaN(max) && v > max) v = max;
    return v;
  }
  function queue(inp, delay) {
    const line = parseInt(inp.closest('.gvm__item').dataset.line, 10);
    const v = clampQty(inp, parseInt(inp.value, 10));
    inp.value = v;
    clearTimeout(timers[line]);
    if (v === parseInt(inp.defaultValue, 10)) return;
    timers[line] = setTimeout(() => change(line, v), delay);
  }
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-gvm-close]')) { e.preventDefault(); close(); return; }
    const st = e.target.closest('[data-gvm-step]');
    if (st) {
      const inp = st.parentElement.querySelector('[data-gvm-qin]');
      let v = (parseInt(inp.value, 10) || 0) + parseInt(st.dataset.gvmStep, 10) * (parseInt(inp.step, 10) || 1);
      const min = parseInt(inp.min, 10) || 1; if (v < min) v = min;
      inp.value = v; queue(inp, 400); return;
    }
    const rm = e.target.closest('[data-gvm-remove]');
    if (rm) { e.preventDefault(); change(parseInt(rm.closest('.gvm__item').dataset.line, 10), 0); }
  });
  root.addEventListener('change', (e) => { if (e.target.matches('[data-gvm-qin]')) queue(e.target, 0); });
  root.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('[data-gvm-qin]')) { e.preventDefault(); queue(e.target, 0); } });

  /* Icon giỏ hàng trên header → mở giỏ nhanh (trang /cart thì vẫn là link) */
  const onCartPage = () => !!document.querySelector('[data-gvk]');
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('.gv-header a[href$="/cart"], #header-group a[href$="/cart"], header-actions a[href$="/cart"]');
    if (!a || onCartPage() || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    if (!root.hidden && root.classList.contains('is-open')) close(); else open(null, a);
  });
  const ic0 = cartIcon(); if (ic0 && !onCartPage()) { ic0.setAttribute('aria-haspopup', 'dialog'); ic0.setAttribute('aria-controls', 'gv-minicart'); ic0.setAttribute('aria-expanded', 'false'); }

  /* Giỏ thay đổi ở nơi khác (trang /cart, nút thêm không gửi kèm khung) → lần mở sau lấy bản mới */
  document.addEventListener(EVT, (e) => { if (e.target !== root && !root.contains(e.target)) stale = true; });
  window.addEventListener('resize', () => { if (!root.hidden) place(); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) { stale = true; close(); } });

  window.GVMini = { open, close, refresh, sectionId: SID, openOnAdd: root.dataset.openOnAdd !== 'false' };
}
